import { nanoid } from 'nanoid';
import { useQueryState } from 'nuqs';
import { useEffect } from 'react';

import { type QueryStateSchema, backwardsCompatabilityFactory, queryParam, queryStateParser } from './queryStateParser';

const QS_KEY = 'paneSubmissionAttemptId';
const QS_TYPE: QueryStateSchema['type'] = 'submissionAttempt';

export const useOpenSubmissionAttemptPane = (): ((args: { submissionAttemptId: string }) => void) => {
  const [submissionAttemptIdDeprecated, setSubmissionAttemptId] = useQueryState(QS_KEY, { history: 'push' });
  const [__, setState] = useQueryState(queryParam, queryStateParser);

  useEffect(() => {
    if (submissionAttemptIdDeprecated) {
      setSubmissionAttemptId(null);
      setState(backwardsCompatabilityFactory({ id: submissionAttemptIdDeprecated, type: QS_TYPE }));
    }
  }, [submissionAttemptIdDeprecated]);

  return ({ submissionAttemptId }) => {
    setState((prevState) => [
      ...(prevState || []),
      {
        id: submissionAttemptId,
        key: nanoid(),
        type: QS_TYPE,
      },
    ]);
  };
};
